export default __webpack_public_path__ + "5cb691db87a3849943861d83f9c240d3.svg";